var _circle, _path, _rect, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0329 22L32.9671 22C33.9872 22 34.3878 20.6486 33.539 20.0706L25.1438 14.3538C24.4512 13.8821 23.5488 13.8821 22.8562 14.3538L14.461 20.0706C13.6122 20.6486 14.0128 22 15.0329 22Z",
    stroke: "#00535C",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 22,
    width: 5,
    height: 8,
    stroke: "#00535C",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22,
    width: 5,
    height: 8,
    stroke: "#00535C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.382 30C31.7607 30 32.107 30.214 32.2764 30.5528L33.2764 32.5528C33.6088 33.2177 33.1253 34 32.382 34L15.618 34C14.8747 34 14.3912 33.2177 14.7236 32.5528L15.7236 30.5528C15.893 30.214 16.2393 30 16.618 30L31.382 30Z",
    stroke: "#00535C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.b2dbc555.svg";
export { ForwardRef as ReactComponent };